/*=========================================================================================
  File Name: moduleAdminGetters.js
  Description: Report Module Getters
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
    // getItem: state => (productId) => state.products.find((product) => product.id == productId),
}